import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'darkMode';
const listeners = new Set();

const readInitial = () => {
  if (typeof window === 'undefined') return false;
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved !== null) return JSON.parse(saved);
  } catch { /* 파싱 실패 시 시스템 설정으로 폴백 */ }
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

// 모듈 단위 단일 상태.
// 이전에는 훅을 호출하는 컴포넌트마다 별도 state 를 가져서
// (예: AppShell 과 설정 화면) 한쪽에서 토글하면 다른 쪽 표시가 어긋났다.
let darkMode = readInitial();

const applyToDocument = (value) => {
  document.documentElement.classList.toggle('dark', value);
};

if (typeof window !== 'undefined') {
  applyToDocument(darkMode);
}

const setDarkMode = (next) => {
  const value = typeof next === 'function' ? next(darkMode) : next;
  if (value === darkMode) return;

  darkMode = value;
  applyToDocument(value);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch { /* 저장 실패는 무시 */ }

  listeners.forEach(listener => listener());
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

const getSnapshot = () => darkMode;
const getServerSnapshot = () => false;

export const useDarkMode = () => [
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot),
  setDarkMode
];
